import memoize from 'lodash/memoize';
import get from 'lodash/get';

import { JobPostings, JobPosting } from 'types';

export default memoize(
  (jobPostings: unknown): JobPostings => {
    if (!Array.isArray(jobPostings) || !get(jobPostings, 'length', 0)) {
      return {};
    }

    return jobPostings.reduce(
      (sanitizedJobPostings: JobPostings, jobPosting: unknown): JobPostings => {
        const department = get(jobPosting, 'categories.department', '');
        const sanitizedJobPosting: JobPosting = {
          description: get(jobPosting, 'description', ''),
          location: get(jobPosting, 'categories.location', ''),
          title: get(jobPosting, 'text', ''),
          link: get(jobPosting, 'hostedUrl', ''),
          id: get(jobPosting, 'id', ''),
        };

        if (sanitizedJobPostings[department]) {
          sanitizedJobPostings[department] = sanitizedJobPostings[
            department
          ].concat([sanitizedJobPosting]);
        } else {
          sanitizedJobPostings[department] = [sanitizedJobPosting];
        }

        return sanitizedJobPostings;
      },
      {}
    );
  }
);
